export default __webpack_public_path__ + "static/media/12.c177f30b.png";